module.exports = __webpack_public_path__ + "static/fonts/SanFranciscoDisplayThin.d2da9d3.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/SanFranciscoDisplayThin.woff
// module id = CGhy
// module chunks = 1